import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fa5d8e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "business-status-popover" }

import { ref, onBeforeMount, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { businessStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { businessDetails, businessStatusRecord, businessChangeStatus } from '@/api/gucangSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'

const __default__ = { name: 'DcCosFbuBusinessView' }

interface StatusStepItem {
  chanceStatus: number
  updateTime: string
  chanceId?: string
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const permissionFollow = {
  edit: 'fbu_business_follow_edit_btn',
  del: 'fbu_business_follow_del_btn',
  comment: 'fbu_business_follow_comment_btn'
}

const queryId = computed(() => route.query.id as string)
const dataForm = ref<FbuBusinessEditParams>({})
const originalStatus = ref<number>()
const waitingChangeStepList = ref<any[]>([])
const stepsList = ref<any[]>([])
const successStep = { chanceName: businessStatusEnum[3].label, chanceStatus: 5, updateTime: '' }
const failStep = { chanceName: businessStatusEnum[4].label, chanceStatus: 6, updateTime: '' }
const getStatusSteps = () => {
  businessStatusRecord(queryId.value).then((res) => {
    if (!res.data || !res.data.length) return
    // const flag = status.value === 6
    // stepsList.value.splice(3, 1, flag ? failStep : successStep)
    stepsList.value.forEach((item: StatusStepItem) => {
      const find = res.data.find((ele: StatusStepItem) => ele.chanceStatus === item.chanceStatus)
      if (find) item.updateTime = find.updateTime
    })
  })
}
const status = ref<number>(1)
const statusComputed = computed(() => {
  if ([4, 5, 6].includes(status.value)) {
    return status.value - 1
  } else {
    return status.value
  }
})
const getDetails = () => {
  return new Promise((resolve) => {
    businessDetails({ id: route.query.id }).then((res) => {
      originalStatus.value = res.data.status
      status.value = res.data.status
      dataForm.value = res.data
      resolve(res.data)
    })
  })
}
const initFn = async () => {
  await getDetails()
  getStatusSteps()
}
watch(
  () => status.value,
  () => {
    const currentStatus = status.value
    if (!currentStatus) {
      return
    }
    stepsList.value = [
      { chanceName: businessStatusEnum[0].label, chanceStatus: 1, updateTime: '' },
      { chanceName: businessStatusEnum[1].label, chanceStatus: 2, updateTime: '' },
      { chanceName: businessStatusEnum[2].label, chanceStatus: 4, updateTime: '' }
    ]
    if (currentStatus === 6) {
      stepsList.value.push({ chanceName: businessStatusEnum[4].label, chanceStatus: 6, updateTime: '' })
    } else if (currentStatus === 8) {
      stepsList.value.push({ chanceName: businessStatusEnum[6].label, chanceStatus: 8, updateTime: '' })
    } else {
      stepsList.value.push({ chanceName: businessStatusEnum[3].label, chanceStatus: 5, updateTime: '' },
        { chanceName: businessStatusEnum[5].label, chanceStatus: 7, updateTime: '' })
    }

    // if (status === 1) {
    //   waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 2 || item.value === 6)
    // } else if (status === 2) {
    //   waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 4 || item.value === 6)
    // } else if (status === 4) {
    //   waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 6)
    // } else {
    //   waitingChangeStepList.value = []
    // }
    if (currentStatus < 4) {
      waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === currentStatus + 1 || item.value === currentStatus + 2 || item.value === 6)
    } else if (currentStatus === 4) {
      waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 6)
    } else if (currentStatus === 6) {
      /// 未能合作商机，支持可以修改商机状态为【初步接洽】、【确认需求】、【制定方案】
      waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value < 5)
    } else {
      waitingChangeStepList.value = []
    }
  },
  { immediate: true }
)
onBeforeMount(() => {
  initFn()
})

// 跳转编辑页面
const handleEdit = () => {
  router.push({ path: '/fbu/business/edit', query: { id: queryId.value } })
}
// 跳转写跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: { followRefId: dataForm.value.saleChanceRefId, chanceId: dataForm.value.id, returnPath: route.fullPath }
  })
}

const businessFormRef = ref()
const loading = ref(false)
const statusChange = (e: any) => {
  loading.value = true
  const params = {
    id: queryId.value,
    status: e.target.value
  }
  businessChangeStatus(params)
    .then(async () => {
      message.success('状态变更成功')
      initFn()
    })
    .catch(() => {
      status.value = dataForm.value.status || 1
    })
    .finally(() => {
      loading.value = false
    })
}

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

return (_ctx: any,_cache: any) => {
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_penetrate_content = _resolveComponent("dc-penetrate-content")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["business-status-steps", { level_5: stepsList.value.length === 5 }])
          }, [
            _createVNode(_component_a_steps, {
              current: statusComputed.value - 1
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepsList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_step, {
                    key: item.chanceStatus,
                    status: item.chanceStatus === 6 ? 'process' : '',
                    title: item.chanceName,
                    description: item.updateTime
                  }, null, 8, ["status", "title", "description"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["current"])
          ], 2),
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: activeTabs.value,
                "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                onChange: handleTabsChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "info",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BusinessForm, {
                        ref_key: "businessFormRef",
                        ref: businessFormRef,
                        title: "基本信息",
                        type: "view",
                        value: dataForm.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm).value = $event)),
                        originalStatus: originalStatus.value
                      }, null, 8, ["value", "originalStatus"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "record",
                    tab: "跟进记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsClueCosFollowUp), {
                        permissionPage: permissionFollow,
                        appId: "cos_fbu",
                        chanceId: queryId.value
                      }, null, 8, ["chanceId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "logs",
                    tab: "操作日志"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        appId: "cos_fbu",
                        resourceId: queryId.value,
                        tableId: "FbuBusinessOperationLog"
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_cos_footer_button, { hideOk: true }, {
        default: _withCtx(() => [
          (dataForm.value.status<=6)
            ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                key: 0,
                workCode: dataForm.value.dutyBy,
                controlType: "none",
                loading: loading.value,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 1
              }, 8, ["workCode", "loading"])), [
                [_directive_permission, 'fbu_business_edit_btn']
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            loading: loading.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleWriteFollowUp()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("写跟进")
            ]),
            _: 1
          }, 8, ["loading"])), [
            [_directive_permission, 'fbu_business_write_follow_btn']
          ]),
          _createVNode(_component_a_popover, {
            placement: "topRight",
            trigger: "hover",
            color: "#132043e5"
          }, {
            content: _withCtx(() => [
              _createVNode(_component_dc_penetrate_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_a_radio_group, {
                      value: status.value,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((status).value = $event)),
                      disabled: loading.value,
                      onChange: statusChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(waitingChangeStepList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_radio, {
                            key: item.value,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("状态变更")
                ]),
                _: 1
              }, 8, ["loading"])), [
                [_directive_permission, 'fbu_business_status_btn']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})